module.exports = __webpack_public_path__ + "img/login-logo.9180d5ed.png";